import type { ComponentPropsWithoutRef, Ref } from "react";

import { cn } from "../lib/utils";

export type WorkspacePageWidth = "readable" | "wide" | "expanded";

const WIDTH_CLASS: Record<WorkspacePageWidth, string> = {
  readable: "max-w-4xl",
  wide: "max-w-5xl",
  expanded: "max-w-6xl",
};

/**
 * Shared content frame for workspace pages, following T3Code. The measure is capped so a wide
 * window does not stretch a list of rows edge to edge, and the same padding lands on every page.
 */
export function WorkspacePageContainer({
  width = "readable",
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<"div"> & {
  readonly width?: WorkspacePageWidth;
  readonly ref?: Ref<HTMLDivElement>;
}) {
  return (
    <div
      ref={ref}
      className={cn(
        "mx-auto flex w-full flex-col gap-6 px-5 pt-6 pb-12 sm:px-6",
        WIDTH_CLASS[width],
        className,
      )}
      {...props}
    />
  );
}
